<template>
  <section>
    <qx-search-box
      class="searchBox"
      :searchBoxData="searchBoxData"
      @sub="sub"
      title="筛选"
      permpisionsQuery=""
    />
    <TableBox ref="tableBox" />
  </section>
</template>

<script>
import TableBox from './tableBox';
import {
  getEnumList,
} from 'api';
export default {
  components: {
    TableBox,
  },
  data () {
    return {
      searchBoxData: {
        paymentWayOptions: [], // 成本模式
        vehicleClassOptions: [], // 车辆类型
        form: [
          { // 车牌号码
            label: '车牌号码',
            value: 'plateNumber',
            type: 'input',
            placeholder: '请输入车牌号码',
          },
          { // 订单号码
            label: '订单号码',
            value: 'orderId',
            type: 'input',
            placeholder: '请输入订单号码',
          },
          { // 发车时间
            label: '发车时间',
            value: 'DependTime',
            type: 'date',
            default: [],
            placeholder: '请选择发车时间',
            attr: {
              type: 'daterange',
            },
          },
          { // 差额比率
            label: '差额比率',
            value: 'Difference',
            type: 'inputrange',
            default: [],
            placeholder: '请输入差额比率',
          },
          { // 成本模式
            label: '成本模式',
            value: 'paymentWay',
            type: 'select',
            default: -1,
            placeholder: '请选择成本模式',
          },
          { // 车辆类型
            label: '车辆类型',
            value: 'vehicleClass',
            type: 'select',
            default: -1,
            placeholder: '请选择车辆类型',
          },
        ],
      },
    };
  },
  methods: {

    /**
     * @param {object} searchBoxData 搜索栏数据
     * @returns {void}
     * @description 搜索栏触发搜索事件，将数据传递给表格box进行保存并刷新数据
     */
    sub (searchBoxData) {
      if (searchBoxData.DependTime[0]) { // 发车时间
        searchBoxData.beginDependTime = this.formatDate(searchBoxData.DependTime[0]);
        searchBoxData.endDependTime = this.formatDate(searchBoxData.DependTime[1]);
      }
      delete searchBoxData.DependTime;
      if (searchBoxData.Difference) { // 差额比率
        searchBoxData.leDifference = searchBoxData.Difference[0];
        searchBoxData.neDifference = searchBoxData.Difference[1];
      }
      delete searchBoxData.Difference;
      this.$refs.tableBox.saveSearchBoxData(searchBoxData);
    },
  },
  async created () {
    const enumsList = await getEnumList({
      codeType: 'PAYMENT_WAY,VEHICLE_CLASS',
    });
    this.searchBoxData.paymentWayOptions = [ // 成本模式
      {
        label: '全部',
        value: -1,
      },
      ...enumsList[0],
    ];
    this.searchBoxData.vehicleClassOptions = [
      {
        label: '全部',
        value: -1,
      },
      ...enumsList[1],
    ];
  },
};
</script>

<style lang="scss" scoped>
</style>
